<template>
  <div class="pic-box">
    <!-- <img class="bg" src="~@images/login.png" alt> -->
    <swiper ref="swiperTop" :options="swiperOptionTop" class="gallery-top"  style="width:600px">
      <swiper-slide v-for="(item, index) in imgList" :key="index">
        <img class="pic-view" :src="item" alt>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      imgList: [
        require('../../../assets/images/pic_flower@2x.png'),
        require('../../../assets/images/pic_mirror@2x.png')
      ],
      swiperOptionTop: {
        nested: true,
        delay: 3000,
        autoplay: true,
        loop: true
      }
    }
  },
  destroyed() {
    this.imgList = []
    this.$refs.swiperTop && this.$refs.swiperTop.destroyed()
  }
}
</script>

<style lang="scss" scoped>
.pic-box {
  position: relative;
  img.bg {
    // width: 500px;
    // height: 430px;
    width: 713px;
    // height: 650px;
    // box-shadow: 0px 10px 20px 0px rgba(181, 177, 221, 0.3);
  }
  img.logo {
    position: absolute;
    bottom: 20px;
    left: 50%;
    margin-left: -65px;
    width: 130px;
  }
  .top {
    position: absolute;
    top: 50%;
    // margin-top: -55px;
    margin-top: -125px;
    // left: 50px;
    width: 100%;
    h1 {
      margin-bottom: 0;
      // margin-top: 20px;
      // margin-bottom: 10px;
      // font-size: 42px;
      font-size: 32px;
      color: #fff;
      text-align: center;
    }
    .trans {
      font-size: 16px;
      color: #fff;
    }
  }
  .bottom {
    position: absolute;
    bottom: 30px;
    left: 50px;
    color: #fff;
  }
}
.swiper-slide {
  text-align: center;
  .pic-view {
    width: 507px;
    height: 524px;
  }
}
</style>


